var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarIllustration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 112,
    viewBox: "0 0 112 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.1033 14.394C55.153 17.6821 57.3254 15.8619 56.797 8.87464C56.3273 2.88558 51.6299 -0.578705 49.9859 3.76633C48.4593 7.70033 48.5767 13.3958 50.1033 14.394Z",
    fill: "#FAA2A2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4227 19.5026C38.8888 20.853 46.7568 21.0292 48.4009 19.8548C51.9826 17.2713 40.5916 13.8658 35.3658 15.9796C33.4869 16.6842 33.9566 18.1521 36.4227 19.5026Z",
    fill: "#FAA2A2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4595 22.9669C44.9365 28.6623 51.1605 38.7029 55.2119 33.8294C56.3862 32.4202 55.7398 25.5504 54.2718 24.0825C52.8039 22.6733 49.1054 21.91 48.4595 22.9669Z",
    fill: "#FAA2A2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M66.3088 20.5593C72.885 19.6786 73.4722 19.5024 73.4722 18.2694C73.4722 15.6272 66.4262 14.5115 60.3784 16.0969C52.804 18.2107 57.56 21.7337 66.3088 20.5593Z",
    fill: "#FAA2A2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M51.9822 89.0817C48.9877 87.6725 38.771 87.7312 38.771 89.1991C38.771 91.1368 42.1766 92.4872 47.6959 92.7808C54.6832 93.0744 56.7383 91.3129 51.9822 89.0817Z",
    fill: "#FAA2A2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M88.2686 25.8435C80.5181 29.0729 71.6519 36.6473 60.3783 41.9318C51.4534 46.1007 46.1689 45.9246 40.1211 42.5777C32.9577 38.7024 29.1999 39.4657 32.6641 44.1043C37.8312 51.0329 36.8917 59.6642 30.2568 65.7707C24.5613 70.9965 30.8433 74.2259 39.5921 70.5854C45.405 68.1781 46.0515 68.2368 53.2149 71.9947C61.9049 76.5745 63.7251 76.3397 64.0187 70.8203C64.2536 65.301 65.9564 59.6642 68.4812 56.0238C72.4152 50.2108 86.742 35.2382 91.4981 31.95C97.9569 27.4876 97.7807 21.9095 88.2686 25.8435ZM59.3801 51.8549C56.914 55.554 55.681 59.077 55.3874 63.011C54.9177 69.7047 55.1526 65.9469 45.4056 63.9505C42.1175 63.3046 41.7652 63.0698 42.0588 62.0129C43.7615 56.0825 43.7615 53.6751 42 49.0365C41.7652 48.4494 42.7047 48.5668 45.4056 49.4475C47.4607 50.0934 50.5726 50.6806 52.3342 50.7393C56.0333 50.8567 58.7342 50.2696 60.6719 49.9173L59.3801 51.8549Z",
    fill: "#FAA2A2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7117 87.3784C40.1209 83.5618 40.0628 80.5673 38.5362 79.0407C36.716 77.2205 33.2517 76.9856 32.3709 78.5709C31.6663 79.8627 32.0773 81.448 32.1948 84.4426C32.3709 88.2004 37.5374 90.5491 38.7117 87.3784Z",
    fill: "#FAA2A2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6645 96.3035C31.4902 98.1824 32.0768 107.636 33.4273 108.751C37.7723 112.274 40.1802 109.104 38.8297 101.588C37.949 96.7732 34.3086 93.6612 32.6645 96.3035Z",
    fill: "#FAA2A2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2218 87.9069C15.5777 88.2592 15.519 89.3748 17.1631 90.784C18.9245 92.3694 29.8464 92.8391 30.3749 91.3125C31.4318 88.6115 23.5637 86.5564 17.2224 87.9069H17.2218Z",
    fill: "#FAA2A2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarIllustration);
export default __webpack_public_path__ + "static/media/star-illustration.28fa6d42d25098441b9c4fe1f9878096.svg";
export { ForwardRef as ReactComponent };